// Supabase browser client — v0.7.0 (Auth + Saved Analyses)
//
// Uses the hosted Supabase project (no local stack — see project memory).
// Only the anon/public key is used here; it is safe to ship in the browser
// because Row Level Security (migration 013) is what actually protects the
// `analyses` table. The service-role key must NEVER appear in frontend code.
//
// Config comes from frontend/.env (REACT_APP_* vars are inlined at build
// time by Create React App). If those are missing, `supabase` is null and
// `isSupabaseConfigured` is false — the UI degrades to a graceful
// "auth unavailable" state instead of crashing, mirroring the geocode
// proxy pattern from v0.6.0.

import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

if (!isSupabaseConfigured && process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line no-console
  console.warn(
    '[supabase] REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY are not set. ' +
      'Copy frontend/.env.example to frontend/.env and fill in both values, ' +
      'then restart `npm start`. Auth features stay disabled until then.'
  );
}

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        // Keep the user signed in across reloads and refresh tokens silently.
        persistSession: true,
        autoRefreshToken: true,
        // Needed so email-confirmation / recovery links land cleanly.
        detectSessionInUrl: true,
        // Namespaced storage key so this app's session never collides with
        // anything else served from the same origin.
        storageKey: 'rv-str-auth',
      },
    })
  : null;

export default supabase;
